import $store from '@/store'
import talkManager from './talkManager'
import {EventBus} from '@/assets/js/event-bus.js'

window.Pusher = require('pusher-js')
var Echo = require('laravel-echo')

export default {
  init (token) {
    var info = $store.getters.auth_get_session_settings.pusher
    console.log('pusher: init', info)
    if (info && token) {
      info = JSON.parse(JSON.stringify(info))
      token = JSON.parse(JSON.stringify(token))
      var echoSession = new Echo({
        broadcaster: 'pusher',
        key: info.key,
        cluster: info.cluster,
        encrypted: info.encrypted,
        authEndpoint: info.auth_url,
        auth: {
          headers: {
            Authorization: 'Bearer ' + token
          }
        },
        namespace: false
      })
      window.pusherSession = echoSession
      $store.commit('AUTH_SET_PUSHER_LISTENER')
      this._checkConnection()
    }
  },

  disconnect () {
    window.pusherSession.disconnect()
  },

  _checkConnection () {
    window.pusherSession.connector.pusher.connection.bind('connecting', this._onConnecting)
    window.pusherSession.connector.pusher.connection.bind('connected', this._onConnected)
    window.pusherSession.connector.pusher.connection.bind('disconnected', this._onDisconnected, this)
  },

  _onDisconnected () {
    this.sessionEnds()
  },

  _onConnected () {
    console.log('pusher: connected')
    var status = $store.getters.auth_get_pusher_connected
    if (status === false) {
      // was disconnected, reload stuff
      // api._loadEventInfo(currentEvent.uid).then(response => {})
    }
    $store.commit('AUTH_SET_PUSHER_CONNECTED_STATUS', true)
  },

  _onConnecting () {
    console.log('pusher: connecting')
    var status = $store.getters.auth_get_pusher_connected
    if (status !== null) {
      $store.commit('AUTH_SET_PUSHER_CONNECTED_STATUS', false)
    }
  },

  initUserChannel (channel) {
    console.log('USER CHANNEL', channel)
    if (channel) {
      var self = this
      window.pusherSession[channel.type](channel.name)
        .listen('App.Events.User.UserAcceptedInSessionEvent', (e) => {
          self._userAccepted(e)
        })
        .listen('App.Events.User.UserUpdatedEvent', (e) => {
          self._accountUpdated(e)
        })
        .listen('App.Events.Cart.CartItemUpdatedEvent', (e) => {
          self._cartItemUpdated(e)
        })
        .listen('App.Events.Cart.CartItemCreatedEvent', (e) => {
          self._cartItemCreated(e)
        })
        .listen('App.Events.Cart.CartItemDeletedEvent', (e) => {
          self._cartItemDeleted(e)
        })
        .listen('App.Events.User.VendorLeftChannelEvent', (e) => {
          self._vendorLeftChannel(e)
        })
        .listen('App.Events.Shop.ShopConnectionEvent', (e) => {
          self._vendorLeftChannel(e)
        })
        .listen('App.Events.User.ShopLineStatusEvent', (e) => {
          console.log('pusher: shop line status event ', e)
          var line = $store.getters.user_get_line(e.line)
          if (!line) {
            $store.dispatch('getLine', {cb () {
              line = $store.getters.user_get_line(e.line)
              if (line) {
                self._checkLineStatus(line)
              }
            }})
          } else {
            $store.commit('USER_UPDATE_LINE_INFO', {uid: line.uid, status: e.status})
            self._checkLineStatus(line)
          }
        })
    }
  },

  _checkLineStatus (line) {
    if (line.status_options['STATUS_SESSION_SUCCESS'] & line.status) {
      this.sessionEnds()
      EventBus.$emit('callStopped', line)
    } else if (!line.is_vendor_in_channel) {
      EventBus.$emit('callStopped', line)
    }
    EventBus.$emit('recheckLineStatus')
  },

  initGeneralChannel (channel) {
    console.log('GENERAL CHANNEL', channel)
    if (channel) {
      // var self = this
      window.pusherSession[channel.type](channel.name)
        .listen('App.Events.Shop.ShopConnectionEvent', (e) => {
          $store.commit('SHOP_SET_STATUS', e)
          $store.commit('USER_SHOP_SET_STATUS', e)
        })
    }
  },

  initShopLinePositionListener (channel) {
    if (channel) {
      window.pusherSession[channel.type](channel.name)
        .listen('App.Events.User.UserLeftLineEvent', (e) => {
          console.log('pusher: shop line user left line ', e)
          $store.dispatch('getLine', {line: e.line})
        })
    }
  },

  _accountUpdated (e) {
    $store.commit('AUTH_SET_ACCOUNT', e.account)
  },

  _userAccepted (e) {
    console.log('pusher: user accepted in session', e)
    EventBus.$emit('callIncoming', {uid: e.line})
    var line = $store.getters.user_get_line(e.line)
    if (line) {
      $store.commit('USER_SET_CURRENT_SESSION_CHANNEL', e.channels['salessession'])
      $store.commit('USER_SET_CURRENT_LIVE_CART', line.cart)
      $store.commit('USER_UPDATE_LINE_INFO', { uid: line.uid, tokbox_session: e.session, token_user: e.token, is_vendor_in_channel: true, vendor: {uid: e.vendor, first_name: e.vendor_name} })
    }
  },

  _vendorLeftChannel (e) {
    $store.commit('USER_VENDOR_LEFT_LINE', e.vendor)
  },

  _cartItemUpdated (e) {
    console.log('pusher: CART ITEM UPDATED', e)
    if ($store.getters.user_get_current_line) {
      var line = $store.getters.user_get_current_line
      $store.dispatch('getCurrentLiveCart', {cart: line.cart.uid})
    }
  },

  _cartItemCreated (e) {
    console.log('pusher: CART ITEM CREATED', e)
    if ($store.getters.user_get_current_line) {
      var line = $store.getters.user_get_current_line
      $store.dispatch('getCurrentLiveCart', {cart: line.cart.uid})
    }
  },

  _cartItemDeleted (e) {
    console.log('pusher: CART ITEM DELETED', e)
    if ($store.getters.user_get_current_line) {
      var line = $store.getters.user_get_current_line
      $store.dispatch('getCurrentLiveCart', {cart: line.cart.uid})
    }
  },

  initSaleSessionChannel (channel) {
    $store.commit('USER_CONNECTING', true)
    if (channel) {
      console.log('pusher: init saleSessionChannel')
      window.pusherSession.join(channel.name)
        .listen('App.Events.Shop.ShopSessionMessageEvent', (e) => {
          this._saveUserMessage(e)
        })
        .here((users) => {
          console.log('pusher: entered sale channel', users)
          var vendorPresent = false
          if (users.length > 1) {
            var accountInfo = $store.getters.auth_get_account
            if (users[0].uid !== accountInfo.uid) {
              vendorPresent = true
            } else if (users[1].uid !== accountInfo.uid) {
              vendorPresent = true
            }
          }
          try {
            if (vendorPresent) {
              $store.commit('WAITING_FOR_VENDOR', false)
              this.sessionConnected()
            } else {
              $store.commit('WAITING_FOR_VENDOR', true)
              EventBus.$emit('vendorDidNotCome')
            }
          } catch (ex) {
            console.log(ex)
          }
        })
        .joining((user) => {
          console.log('pusher: vendor joining', user)
          var accountInfo = $store.getters.auth_get_account
          if (user.uid !== accountInfo.uid) {
          //   $store.commit('PUSHER_CUSTOMER', user) //
            $store.commit('WAITING_FOR_VENDOR', false)
            this.sessionConnected()
          }
        })
        .leaving((user) => {
          console.log('pusher: vendor leaving', user)
          EventBus.$emit('vendor_left')
          $store.dispatch('sessionStatus', {line: $store.getters.user_get_current_line, status: 'sessionError'})
          EventBus.$emit('callStopped', $store.getters.user_get_current_line)
        })
    }
  },

  sessionStarts () {
    var channel = $store.getters.user_get_session_channel
    this.initSaleSessionChannel(channel) //
  },

  sessionConnected () {
    var token = $store.getters.user_get_session_token
    $store.commit('USER_CONNECTING', false)
    $store.commit('USER_SESSION_STARTED')
    talkManager.initSession(token)
  },

  sessionEnds () {
    console.log('Ending Session')
    talkManager.closeSession()
  },

  leaveSaleChannel () {
    EventBus.$emit('callStopped', $store.getters.user_get_current_line)
    var channel = $store.getters.user_get_session_channel
    this.leavePresenceChannel(channel)
    $store.commit('USER_SESSION_ENDED')
  },

  leavePresenceChannel (channel) {
    if (channel) {
      window.pusherSession.leave(channel.name)
    }
  },

  _saveUserMessage (e) {
    console.log('message incoming ', e)
    $store.commit('USER_ADD_SESSION_MESSAGE', e.message)
    EventBus.$emit('chat_message_came')
  }

}



// WEBPACK FOOTER //
// ./src/assets/js/pusherManager.js